<template>
  <div class="return-order">
    <Form :model="formItem"
          ref="formItem"
          :inline="true"
          action="javascript:void(0)">
      <FormItem>
        <Input v-model="formItem.key"
               placeholder="输入订单编号..." />
      </FormItem>
      <FormItem>
        <Select v-model="formItem.status"
                clearable
                filterable
                placeholder="订单状态...">
          <Option v-for="item in returnorderStatusList"
                  :value="item.id"
                  :key="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Select v-model="formItem.pay_name"
                clearable
                filterable
                placeholder="收单机构">
          <Option v-for="item in payNameList"
                  :value="item.id"
                  :key="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Button type="primary"
                @click="renderTable('formItem')">筛选</Button>
      </FormItem>
    </Form>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <!-- 审核弹框 -->
    <Form action="javascript:void(0)">
      <Modal v-model="showModalStatus"
             title="审核"
             @on-ok="reviewOrder()"
             :loading="dataloading">
        <FormItem label="状态"
                  label-position="top">
          <Select v-model="returndata.status1"
                  clearable
                  filterable
                  placeholder="状态"
                  v-if="this.returndata.status==0||this.returndata.status==8||this.returndata.status==7||this.returndata.status==5">
            <Option :value="12"
                    :key="12"
                    v-if="this.returndata.status!=5&&this.returndata.return_type==2">同意退款，请寄回商品</Option>
            <Option :value="9"
                    :key="9"
                    v-if="this.returndata.status!=5&&this.returndata.return_type==1">同意退款，退款中</Option>
            <Option :value="6"
                    :key="6"
                    v-if="this.returndata.status==5">确认收货</Option>
            <Option :value="2"
                    :key="2"
                    v-if="this.returndata.status!=5">拒绝用户售后</Option>
          </Select>
        </FormItem>
        <FormItem label="平台备注"
                  label-position="top">
          <Input type="textarea"
                 v-model="returndata.plat_mark"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>
      </Modal>
    </Form>
    <!-- 审核弹框 end -->
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.current"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 详情弹层 start-->
    <Drawer width="50"
            v-model="showDetailModalStatus"
            title="订单详情"
            :mask-closable="false"
            @on-cancel="showDetailModalStatus = false">
      <Row>
        <Col :xs="24"
             :md="24">
        <div v-model="orderdetail">
          <div>
            <span class="key_name">应退还金额:</span>
            <span>{{orderdetail.real_return_price}}</span>
          </div>
          <div>
            <span class="key_name">平台审核意见:</span>
            <span>{{orderdetail.plat_mark}}</span>
          </div>
          <div>
            <span class="key_name">商户审核意见:</span>
            <span>{{orderdetail.shopmark}}</span>
          </div>
          <div>
            <span class="key_name">审核时间:</span>
            <span>{{orderdetail.review_at}}</span>
          </div>
          <div>
            <span class="key_name">退货物流编号:</span>
            <span>{{orderdetail.return_logistics_code}}</span>
          </div>
          <div>
            <span class="key_name">退货物流公司:</span>
            <span>{{orderdetail.return_logistics_name}}</span>
          </div>
          <div>
            <span class="key_name">退货时间:</span>
            <span>{{orderdetail.returngood_at}}</span>
          </div>
          <div>
            <span class="key_name">审核人:</span>
            <span>{{orderdetail.adminname}}</span>
          </div>
        </div>
        </Col>
      </Row>
    </Drawer>
    <!-- 详情弹层 end -->
  </div>
</template>

<script>
export default {
  name: "return-order",
  data () {
    return {
      loading: true,
      dataloading: true,
      showModalStatus: false,
      showDetailModalStatus: false,
      orderdetail: {},
      formItem: {
        key: ""
      },
      returnorderStatusList: [
        { id: 0, name: "商家受理中" },
        { id: 1, name: "退款成功" },
        { id: 2, name: "平台拒绝用户售后" },
        // { id: 3, name: "商家同意退款，退款中" },
        { id: 4, name: "商家同意退款，请寄回商品" },
        { id: 5, name: "待商家收货" },
        // { id: 6, name: "商家确认收货，退款中" },
        { id: 7, name: "商家拒绝退款" },
        { id: 8, name: "平台介入中" },
        // { id: 9, name: "平台同意退款，退款中" },
        { id: 10, name: "退款失败" },
        { id: 11, name: "用户取消售后" },
        { id: 12, name: "平台同意退款，请寄回商品" }
      ],
      loginst: [],
      payNameList: [
        { id: 0, name: "融宝" },
        { id: 1, name: "财付通" },],
      returndata: {
        status: "1",
        plat_mark: ""
      },
      pages: {
        current: 1,
        size: 10
      },
      list: [

        {
          title: "订单编号",
          align: "center",
          key: "order_num",
          width: 185,
          fixed: "left"
        },
        {
          title: "支付单号",
          align: "center",
          key: "pay_order_num",
          minWidth: 185
        },
        {
          title: "订单ID",
          align: "center",
          key: "id",
          width: 185,
        },
        {
          title: "会员名",
          width: 185,
          align: "center",
          key: "phone"
        },
        {
          title: "订单类型",
          minWidth: 185,
          align: "center",
          key: "return_type"
        },
        {
          title: "商品信息",
          minWidth: 185,
          align: "center",
          key: "good_title"
        },
        {
          title: "商品数量",
          width: 120,
          align: "center",
          key: "nums"
        },
        {
          title: "商品金额",
          width: 185,
          align: "center",
          key: "total_prices"
        },
        {
          title: "退款原因",
          width: 150,
          align: "center",
          key: "mark"
        },
        {
          title: "状态",
          minWidth: 100,
          align: "center",
          key: "status"
        },
        {
          title: "提交时间",
          minWidth: 100,
          align: "center",
          key: "created_at"
        },
        {
          title: "退款时间",
          minWidth: 100,
          align: "center",
          key: "return_at"
        },
        {
          title: "操作",
          align: "center",
          key: "action",
          width: 300,
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display:
                      params.row.status_num == "0" || params.row.status_num == "5" || params.row.status_num == "8"
                        ? "inline-block"
                        : "none"
                  },
                  on: {
                    click: () => {
                      this.review(params.row.id);
                    }
                  }
                },
                params.row.status_num == "5" ? "确认收货" : (params.row.status_num == "8" ? "平台介入" : "审核")
              ),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.detail(params.row.id)
                  }
                }
              }, '详情')
            ]);
          }
        }
      ],
      tablelist: []
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {
    "$route.params.is_platprice": function (newVal, oldVal) {
      this.order_id = this.$route.params.id;
      this.is_platprice = this.$route.params.is_platprice;
      // 取数据
      this.getTableList();
    }
  },
  created: function () {
    this.order_id = this.$route.params.id;
    this.is_platprice = this.$route.params.is_platprice;
    this.formItem.status = this.$route.params.status != -1 ? parseInt(this.$route.params.status) : null;

    // 取数据
    this.getTableList();
  },
  methods: {
    // 获取订单列表
    getTableList: function () {
      var params = {
        page: this.pages.current,
        size: this.pages.size,
        is_platprice: this.is_platprice,
        status: this.formItem.status
      };
      this.$api.returnorder.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 分页
    changePage () {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.getTableList();
    },
    // 删除
    remove: function (id) {
      this.$api.returnorder.remove({ return_id: id }).then(res => {
        if (res.code == 200) {
          this.getTableList();
        }
      });
      return;
    },
    review: function (id) {
      this.return_id = id;
      this.returndata.status1 = "";
      this.returndata.plat_mark = "";
      this.$api.returnorder.detail({ id: id }).then(res => {
        this.returndata.status = res.result.status;
        this.returndata.return_type = res.result.return_type;
      });
      this.showModalStatus = !this.showModalStatus;

    },
    // 添加
    reviewOrder: function (name) {
      this.$api.returnorder
        .newreview({
          return_id: this.return_id,
          status: this.returndata.status1,
          plat_mark: this.returndata.plat_mark
        })
        .then(res => {
          if (res.code == 200) {
            this.getTableList();
          }
        });
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    // 筛选
    renderTable: function (name) {
      let params = {
        page: this.pages.current,
        size: this.pages.size,
        key: this.formItem.key,
        status: this.formItem.status,
        pay_name: this.formItem.pay_name,
        is_platprice: this.is_platprice
      };
      this.$api.returnorder.list(params).then(res => {
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    },
    // 详情
    detail (id) {
      this.title = "退款详情";
      this.showDetailModalStatus = true;
      this.$api.returnorder.detail({ id: id }).then(res => {
        this.orderdetail = res.result;
      });
    },
  }
};
</script>
